﻿import { View, LabeledFieldView, createLabeledInputText } from 'ckeditor5';
import { debounce } from '@eworx/ckeditor5/utils';

function createSearchView(locale) {
    const { t } = locale;

    const searchView = new View(locale);

    const labeledInputView = new LabeledFieldView(locale, createLabeledInputText);
    const triggerSearchDebounced = debounce((searchExpression) => {
        searchView.fire('change:searchExpression', searchExpression);
    }, 250);

    labeledInputView.fieldView.on('input', (evt, data) => {
        triggerSearchDebounced(data.target.value);
    });

    labeledInputView.set({
        label: t('Search emoji'),
        class: 'ck-emoji-search'
    });

    searchView.setTemplate({
        tag: 'div',
        attributes: {
            class: ['ck', 'ck-form__header'],
        },
        children: [labeledInputView]
    });

    return searchView;
}

export { createSearchView };